import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const DomainsTable = ({ domains, onEdit, onRemove, onSort }) => {
    const rows = domains.map((domain, index) => <Row key={index} domain={domain} onEdit={onEdit} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSort('subdomain_domain')}>Subdomain.Domain</th>
                    <th onClick={() => onSort('domain')}>Domain</th>
                    <th onClick={() => onSort('hour')}>hour</th>
                    <th onClick={() => onSort('type')}>Type</th>
                    <th onClick={() => onSort('flagged')}>Flagged</th>
                    <th onClick={() => onSort('flaggedAt')}>Last Checked</th>
                    <th onClick={() => onSort('virusTotal')}>Virus Total</th>
                    <th onClick={() => onSort('sucuri')}>Sucuri</th>
                    <th onClick={() => onSort('norton')}>Norton</th>
                    <th onClick={() => onSort('avast')}>Avast</th>
                    <th onClick={() => onSort('google')}>Google</th>

                    <th style={{ width: '12%' }} onClick={() => onSort('note')}>Note</th>

                    <th>Action</th>
                </tr>
            </thead>

            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default DomainsTable;



// WEBPACK FOOTER //
// ./src/scenes/Domains/components/Table/index.js